<template>
  <div class="log">
    <v-btn
      class="messagebtn milestone-log-action-btn"
      flat
      prepend-icon
      @click.stop="check()"
      >View Milestone Logs</v-btn
    >
    <v-dialog
      v-model="dialog"
      content-class="milestone-log-dialog"
    >
      <v-card class="milestone-log-card">
        <v-toolbar flat class="milestone-log-toolbar">
          <v-toolbar-title>View Milestone Logs</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.prevent="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="milestone-log-body">
          <ol v-if="activity.length" class="milestone-log-list">
            <li
              v-for="(data, i) in activity"
              :key="i"
              class="milestone-log-item"
              :class="{ 'is-pending': !data.updatedDate }"
            >
              <div class="milestone-log-date">
                <template v-if="data.updatedDate">
                  <v-icon small>event</v-icon>
                  <strong>{{ dayMonth(data.updatedDate) }}</strong>
                  <span
                    >{{ year(data.updatedDate) }} ·
                    {{ time(data.updatedDate) }}</span
                  >
                </template>
                <template v-else>
                  <v-icon small>hourglass_empty</v-icon>
                  <strong>Pending</strong>
                </template>
              </div>
              <div class="milestone-log-rail">
                <span class="milestone-log-dot"></span>
              </div>
              <div class="milestone-log-card-item">
                <span class="milestone-log-name">{{ data.mileStoneName }}</span>
                <div class="milestone-log-field">
                  <span class="milestone-log-label">Actual Milestone Date</span>
                  <span class="milestone-log-value">{{
                    data.updatedDate ? getTime(data.updatedDate) : "Not reached yet"
                  }}</span>
                </div>
                <div
                  class="milestone-log-comment"
                  :class="{ 'is-empty': !data.comments }"
                >
                  <v-icon small>chat_bubble_outline</v-icon>
                  <span>{{ data.comments || "No comment" }}</span>
                </div>
              </div>
            </li>
          </ol>
          <div v-else class="milestone-log-empty">No Milestones Found</div>
        </div>
      </v-card>
    </v-dialog>

    <v-snackbar
      :timeout="3000"
      color="red darken-2"
      v-model="x.error"
      class="white--text"
      v-if="x.error"
      >{{ x.error }}</v-snackbar
    >
  </div>
</template>
<script>
import moment from "moment";
import ErrorBox from "@/components/Common/ErrorBox";
import { StorageKeys } from "../../constants/constants";
import { trackingStatus } from "@/constants/api-urls.js";
import "moment/locale/es"; // without this line it didn't work
moment.locale("en-in");
export default {
  data() {
    return {
      x: {
        error: null,
      },
      operationName: "",
      activity: [],
      reason: "",
      dialog: false,
      disStatus: false,
      loading: false,
      rules: {
        required: (value) => !!value || "This field is required.",
      },
    };
  },
  props: {
    jobId: Number,
    assignmentId: Number,
  },
  created() {
    this.getActivityLog();
  },
  components: {
    ErrorBox,
  },
  methods: {
    async check() {
      this.operationName = "view-comments-jobs";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.dialog = true;
        this.getActivityLog();
      } else {
        return;
      }
    },

    getTime(date) {
      return moment(date).format("ll  LT");
    },
    getDate(date) {
      return moment(date).format("ll");
    },
    dayMonth(date) {
      return moment(date).format("DD MMM");
    },
    year(date) {
      return moment(date).format("YYYY");
    },
    time(date) {
      return moment(date).format("h:mm A");
    },
    getActivityLog() {
      if (this.processing) {
        return;
      } else {
        this.processing = true;
        let url = trackingStatus;
        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };
        let body = {
          assId: this.$props.assignmentId.toString(),
        };
        this.axios.post(this.constants.apiUrl + url, body, config).then(
          (response) => {
            this.activity = response.data.data;

            this.processing = false;
          },
          (error) => {
            this.x.error = "Failed to Fetch Comments";
            this.processing = false;
          }
        );
      }
    },
  },
};
</script>
<style scoped>
.break_long_text {
  word-break: break-all;
  word-break: break-word;
  hyphens: auto;
}
.user {
  padding: 10px;
}
.log {
  display: inline-flex;
  flex: 0 0 auto;
  margin: 0;
}
.milestone-log-action-btn {
  align-items: center !important;
  background: var(--oms-surface, #ffffff) !important;
  border: 0.0625rem solid var(--oms-primary, #ea7a1c) !important;
  border-radius: var(--oms-control-radius, 0.625rem) !important;
  box-shadow: none !important;
  color: var(--oms-primary-dark, #d96a10) !important;
  display: inline-flex !important;
  font-family: "Geist", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  height: var(--oms-control-height, 2.375rem) !important;
  justify-content: center !important;
  letter-spacing: 0 !important;
  line-height: 1 !important;
  min-height: var(--oms-control-height, 2.375rem) !important;
  min-width: 0 !important;
  padding: 0 0.75rem !important;
  text-transform: none !important;
  white-space: nowrap !important;
}
.milestone-log-action-btn:hover,
.milestone-log-action-btn:focus {
  background: var(--oms-primary-soft, #fdf0e4) !important;
  border-color: var(--oms-primary-dark, #d96a10) !important;
  color: var(--oms-primary-dark, #d96a10) !important;
}

/* Milestone log dialog: date tile | timeline dot | detail card per milestone. */
.milestone-log-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.milestone-log-toolbar {
  flex: 0 0 auto;
}

.milestone-log-body {
  background: var(--oms-surface-soft, #faf9f6);
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 1rem 1.25rem 1.25rem;
}

.milestone-log-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.milestone-log-item {
  display: grid;
  gap: 0 0.875rem;
  grid-template-columns: 8.5rem 1rem minmax(0, 1fr);
  padding-bottom: 0.75rem;
}

.milestone-log-item:last-child {
  padding-bottom: 0;
}

/* Date tile */
.milestone-log-date {
  align-items: center;
  align-self: center;
  background: var(--oms-navy, #1c2b5f);
  border-radius: 0.625rem;
  box-shadow: 0 0.25rem 0.75rem rgba(28, 43, 95, 0.2);
  color: #ffffff;
  column-gap: 0.4375rem;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  min-height: 3rem;
  padding: 0.5rem 0.625rem;
}

.milestone-log-date .v-icon {
  color: var(--oms-primary, #ea7a1c) !important;
  font-size: 1.125rem !important;
  grid-row: 1 / span 2;
}

.milestone-log-date strong {
  font-size: 0.9375rem;
  font-weight: 800;
  line-height: 1.15;
  white-space: nowrap;
}

.milestone-log-date span {
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.6875rem;
  font-weight: 600;
  white-space: nowrap;
}

.milestone-log-item.is-pending .milestone-log-date strong {
  font-size: 0.8125rem;
  grid-row: 1 / span 2;
}

.milestone-log-item.is-pending .milestone-log-date {
  background: var(--oms-surface, #ffffff);
  border: 0.0625rem dashed var(--oms-border-strong, #d2cec3);
  box-shadow: none;
  color: var(--oms-muted, #74716a);
}

.milestone-log-item.is-pending .milestone-log-date .v-icon {
  color: var(--oms-muted, #74716a) !important;
}

/* Timeline rail */
.milestone-log-rail {
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
}

.milestone-log-rail::before {
  background: var(--oms-border-strong, #d2cec3);
  bottom: -1.25rem;
  content: "";
  left: 50%;
  position: absolute;
  top: 0;
  transform: translateX(-50%);
  width: 0.125rem;
}

.milestone-log-item:first-child .milestone-log-rail::before {
  top: 50%;
}

.milestone-log-item:last-child .milestone-log-rail::before {
  bottom: 50%;
}

.milestone-log-item:only-child .milestone-log-rail::before {
  display: none;
}

.milestone-log-dot {
  background: var(--oms-primary, #ea7a1c);
  border: 0.1875rem solid var(--oms-surface, #ffffff);
  border-radius: 50%;
  box-shadow: 0 0 0 0.125rem var(--oms-primary, #ea7a1c);
  align-self: center;
  height: 0.875rem;
  position: relative;
  width: 0.875rem;
  z-index: 1;
}

.milestone-log-item.is-pending .milestone-log-dot {
  background: var(--oms-surface, #ffffff);
  box-shadow: 0 0 0 0.125rem var(--oms-border-strong, #d2cec3);
}

/* Detail card */
.milestone-log-card-item {
  background: var(--oms-surface, #ffffff);
  border: 0.0625rem solid var(--oms-border, #ebe9e2);
  border-radius: 0.75rem;
  align-items: center;
  box-shadow: 0 0.125rem 0.5rem rgba(26, 25, 22, 0.05);
  display: grid;
  gap: 0.5rem 1rem;
  grid-template-columns: minmax(6rem, 0.8fr) auto minmax(0, 1fr);
  min-width: 0;
  padding: 0.75rem 1rem;
  position: relative;
}

/* Small pointer towards the timeline dot. */
.milestone-log-card-item::before {
  background: var(--oms-surface, #ffffff);
  border-bottom: 0.0625rem solid var(--oms-border, #ebe9e2);
  border-left: 0.0625rem solid var(--oms-border, #ebe9e2);
  content: "";
  height: 0.625rem;
  left: -0.375rem;
  position: absolute;
  top: calc(50% - 0.3125rem);
  transform: rotate(45deg);
  width: 0.625rem;
}

.milestone-log-name {
  justify-self: start;
  background: var(--oms-primary-soft, #fdf0e4);
  border-radius: 0.375rem;
  color: var(--oms-primary-dark, #d96a10);
  font-size: 0.8125rem;
  font-weight: 800;
  max-width: 100%;
  overflow-wrap: anywhere;
  padding: 0.25rem 0.625rem;
}

.milestone-log-item.is-pending .milestone-log-card-item {
  box-shadow: none;
}

.milestone-log-item.is-pending .milestone-log-name {
  background: var(--oms-surface-soft, #f4f3ee);
  color: var(--oms-muted, #74716a);
}

.milestone-log-field {
  border-left: 0.0625rem solid var(--oms-border, #ebe9e2);
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  padding-left: 1rem;
}

.milestone-log-label {
  color: var(--oms-muted, #74716a);
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}

.milestone-log-value {
  color: var(--oms-navy, #1c2b5f);
  font-size: 0.8125rem;
  font-weight: 700;
  white-space: nowrap;
}

.milestone-log-item.is-pending .milestone-log-value {
  color: var(--oms-muted, #74716a);
  font-weight: 600;
}

.milestone-log-comment {
  align-items: flex-start;
  border-left: 0.0625rem solid var(--oms-border, #ebe9e2);
  color: var(--oms-ink, #3a382f);
  display: flex;
  font-size: 0.8125rem;
  gap: 0.5rem;
  line-height: 1.4;
  padding-left: 1rem;
}

.milestone-log-comment.is-empty {
  color: var(--oms-disabled-ink, #b4b0a6);
}

.milestone-log-comment.is-empty .v-icon {
  color: var(--oms-disabled-ink, #b4b0a6) !important;
}

.milestone-log-comment span {
  min-width: 0;
  overflow-wrap: anywhere;
}

.milestone-log-comment .v-icon {
  color: var(--oms-primary, #ea7a1c) !important;
  margin-top: 0.0625rem;
}

.milestone-log-empty {
  color: var(--oms-muted, #74716a);
  font-size: 0.875rem;
  padding: 2rem 0;
  text-align: center;
}

/* Narrow screens: stack the card's three parts again. */
@media (max-width: 48rem) {
  .milestone-log-card-item {
    grid-template-columns: minmax(0, 1fr);
  }

  .milestone-log-field,
  .milestone-log-comment {
    border-left: 0;
    border-top: 0.0625rem solid var(--oms-border, #ebe9e2);
    padding-left: 0;
    padding-top: 0.5rem;
  }
}
</style>
